export function startLoading() {
  this.appLoading = true
}

export function finishLoading() {
  this.appLoading = false
}
